import { Modal } from "@mantine/core";
import AddEligibilityRuleForm, {
  EligibilityRuleDraft,
} from "./AddEligibilityRuleForm";

interface AddEligibilityRuleModalProps {
  opened: boolean;
  onClose: () => void;
  existingProviderIds: string[];
  hasCatchAll: boolean;
  onConfirm: (draft: EligibilityRuleDraft) => void;
}

export default function AddEligibilityRuleModal({
  opened,
  onClose,
  existingProviderIds,
  hasCatchAll,
  onConfirm,
}: AddEligibilityRuleModalProps) {
  // Remount the form on each open so its fields reset without a state-watching effect.
  const formKey = opened ? "open" : "closed";

  return (
    <Modal.Root
      opened={opened}
      onClose={onClose}
      size="md"
      centered
      styles={{
        content: {
          display: "flex",
          flexDirection: "column",
          maxHeight: "85vh",
        },
      }}
    >
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>Add Eligibility Rule</Modal.Title>
          <Modal.CloseButton />
        </Modal.Header>
        <AddEligibilityRuleForm
          key={formKey}
          existingProviderIds={existingProviderIds}
          hasCatchAll={hasCatchAll}
          onConfirm={onConfirm}
          onClose={onClose}
        />
      </Modal.Content>
    </Modal.Root>
  );
}
